import type { ReactNode } from "react";

/** Shared hierarchy for workspace pages and the editorial trip/booking surfaces. */
export default function PageHeader({ title, subtitle, action, editorial = false }: {
  title: ReactNode;
  subtitle?: ReactNode;
  action?: ReactNode;
  editorial?: boolean;
}) {
  return (
    <header className="page-header">
      <div className="min-w-0 max-w-2xl">
        <h1 className={editorial ? "page-title page-title-editorial" : "page-title"}>{title}</h1>
        {subtitle && <p className="mt-2 text-sm leading-relaxed text-primary-700 sm:text-base">{subtitle}</p>}
      </div>
      {action && <div className="flex shrink-0 flex-wrap items-center gap-2">{action}</div>}
    </header>
  );
}
